import {
    apiRequest
    // , whmcs 
} from "../../apiCall"
import axios from 'axios'


export const getDepartmentsRequest = (params) => apiRequest('APIRunner.TestApiRunner', { ...params })

// () => {
//     return whmcs.call("GetSupportDepartments").then(response => response)


// }



export const createTicketRequest = (params) => apiRequest('APIRunner.TestApiRunner', { ...params }, '', "OpenTicket")
//  (params) => {

//     return whmcs.call('OpenTicket', params
//     ).then(response => response)

// }


export const getTicketsRequest = (params) => apiRequest('APIRunner.TestApiRunner', { ...params })

// () => {

//     return whmcs.call('GetTickets', { clientid: 37 }
//     ).then(response => response)

// }

export const getTicketRequest = (params) => apiRequest('APIRunner.TestApiRunner', { ...params })

// (id) => {

//     return whmcs.call('GetTicket', { ticketid: id }
//     ).then(response => response)

// }

export const replayTicketRequest = (params) =>
    // axios.post("http://localhost:8000/test", params)

    apiRequest('APIRunner.TestApiRunner', { ...params }, '', "AddTicketReply")


//  (params) => {

//     return whmcs.call('AddTicketReply', params
//     ).then(response => response)
// }


export const getTicketAttachmentRequest = (params) => apiRequest('APIRunner.TestApiRunner', { ...params })

//     (params) => {

//     return whmcs.call('GetTicketAttachment', params
//     ).then(response => response)
// }

export const postTicketAPIRunnerRequest = (params) => apiRequest('APIRunner.TestApiRunner', { ...params })

